import React from 'react';
import PropTypes from 'prop-types';
import NavbarButton from './NavbarButton';
import {ADD_GLYPH, HOME_GLYPH, SEARCH_GLYPH} from '../../const/Glyphicons';
import textTranslates from './translate.json';

const CollapseMenu = ({onCreateComplaintClick, onHomeBtnClick, onPreviewComplaintClick}) => {
    return(
        <div className="col-sm-7 col-md-8 col-lg-8 menu-items">
            <div className="menu-buttons col-xs-12 col-sm-offset-4 col-sm-8 col-md-offset-1 col-md-11 col-lg-offset-3 col-lg-9">
                <ul className="nav navbar-nav buttons-list">
                    <li>
                        <NavbarButton
                            htmlId="btnHome"
                            onClick={onHomeBtnClick}
                            className="home-button"
                            glyph={HOME_GLYPH} />
                    </li>
                    <li>
                        <NavbarButton
                            htmlId="btnCreateComplaint"
                            onClick={onCreateComplaintClick}
                            glyph={ADD_GLYPH}
                            text={textTranslates.btnCreateComplaintText} />
                    </li>
                    <li>
                        <NavbarButton
                            htmlId="btnPreviewComplaint"
                            onClick={onPreviewComplaintClick}
                            glyph={SEARCH_GLYPH}
                            text={textTranslates.btnPreviewComplaintText} /></li>
                </ul>
            </div>
        </div>
    );
};

CollapseMenu.propTypes = {
    onCreateComplaintClick: PropTypes.func.isRequired,
    onHomeBtnClick: PropTypes.func.isRequired,
    onPreviewComplaintClick: PropTypes.func.isRequired
};

export default CollapseMenu;


// WEBPACK FOOTER //
// ./src/components/TopMenu/CollapseMenu.js